import React from 'react'

import { Loader2 } from 'lucide-react';
import { Chart } from 'twyne-new.ui';

import { HeaderSeparator, ReportHeader, ReportHeaderDates, ReportHeaderDesktopActions, ReportHeaderMobileActions, TriggerDatePicker } from '@/components/reports/header';

export default class DrilldownHeader extends React.Component {
  Loading = () => {
    if (this.props.isLoading) {
      return <Loader2 className="animate-spin" size="16" />
    }

    return null
  }

  Title = () => <>
    {this.props.title}
    <this.Loading />
  </>

  Dates = () => {
    const { startDate, endDate } = this.props

    if (startDate && endDate) {
      return <TriggerDatePicker values={{ startDate, endDate }} />
    }

    return null
  }

  Statistics = () => {
    const { total, showing } = this.props

    return <>
      <Chart text='Total' value={total} />
      <Chart text='Showing' value={showing} total={total} color='warning' />
    </>
  }

  render() {
    return <ReportHeader
      title={<>
        <span className='font-bold'>{this.props.collection}</span>
        <span className='mx-1'>•</span>
        <span>{this.props.title}</span>
      </>}
    >
      <ReportHeaderDates>
        <this.Dates />
      </ReportHeaderDates>
      <HeaderSeparator />
      <ReportHeaderDesktopActions>
        <this.Statistics />
      </ReportHeaderDesktopActions>
      <ReportHeaderMobileActions>
        {this.props.mobileActions}
      </ReportHeaderMobileActions>
    </ReportHeader>
  }
}
